import classNames from "classnames";
import { RefObject } from "react";
import { GameRound } from "shared/games/types/GameRound";
import useOnChangeHandler from "../../../../molecules/GameRoundBuilders/useOnChangeHandler";
import InstrumentSelector from "./InstrumentSelector";
import AdvancedTechniqueAndGameSelector from "./AdvancedTechniqueAndGameSelector";
import { InstrumentsConfig } from "shared/games/instruments/instrumentsConfig";
import { AllTechniqueGameDescriptions } from "shared/games/allTechniqueGameDescriptions";
import { Technique } from "shared/games/technique";

interface Props {
  techniquesAndGames: AllTechniqueGameDescriptions;
  advancedRef: RefObject<HTMLDivElement>;
  instruments: InstrumentsConfig;
  value: GameRound;
  changers: ReturnType<typeof useOnChangeHandler>;
}

export default function AdvancedOptions({
  advancedRef,
  techniquesAndGames,
  instruments,
  changers,
  value,
}: Props) {
  const techniques = Object.values(techniquesAndGames);

  return (
    <div ref={advancedRef}>
      <div className={classNames("mb-10 grid grid-cols-1")}>
        {techniques.map((technique, index) => {
          if (technique.technique === Technique.mixPuzzle) return null;

          return (
            <AdvancedTechniqueAndGameSelector
              key={technique.technique}
              index={index}
              technique={technique}
              techniques={techniques}
              changers={changers}
              value={value}
            />
          );
        })}
      </div>

      <InstrumentSelector
        instruments={instruments}
        value={value}
        changers={changers}
      />
    </div>
  );
}
